module.exports = __webpack_public_path__ + "static/img/1.fd27f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner/1.jpg
// module id = 3qjg
// module chunks = 9